import React from 'react';

const Services = () => {
  return <h1>Work</h1>
}

export default Services